import { Component, OnInit, Input, OnDestroy, Output, ViewChild, TemplateRef } from '@angular/core';
import { ScreeningLight, ObjectUpdatePayload, Screening } from 'src/app/models/screeningInvite';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/users-module/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { GroupApplicantComponent } from 'src/app/shared-components-module/group-applicant/group-applicant.component';
import { ToastrService } from 'ngx-toastr';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { Router } from '@angular/router';
import { FilteringService } from 'src/app/services/filtering.service';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { PaginationService } from '../pagination-top/services/pagination.service';
import { OrderByDesignator } from 'src/app/models/ScreeningFilter';
import { Subject, Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RiqAlertComponent } from '../riq-alert/riq-alert.component';
import { ReportTaggingService } from 'src/app/services/report-tagging.service';

@Component({
  selector: 'app-screening-list',
  templateUrl: './screening-list.component.html',
  styleUrls: ['./screening-list.component.less']
})
export class ScreeningListComponent implements OnInit, OnDestroy {
  public dialogRef: any;
  constructor(private screenings : ScreeningService,
    private auth : AuthService,
    private users : UserService,
    public toast: ToastrService,
    private groupSvc : GroupApplicantsService,
    private location : Router,
    public pagination : PaginationService,
    public filtering : FilteringService,
    public modalService: NgbModal,
    public tagging: ReportTaggingService) { }
  ngOnDestroy(): void {
    this.screeningsLoadedSub?.unsubscribe();
    this.screenings.screenings = [];
  }

  @Input()
  public clientId: number;

  @Input()
  public take: number = 30;

  @Input()
  public craCheck: boolean;

  @Input() 
  public propertyId: number;

  @Input()
  public skipInitialLoad : boolean = false;

  @Input()
  public processingListOrigin : boolean = false;

  /** RIQ-5132: When true, show "income received, needs work" indicator and call income-verification-tagged-ids. Only set on Screenings page. */
  @Input()
  public showIncomeReceivedIndicator = true;

  @Output()
  public orderingTrigger : Subject<boolean> = new Subject();

  /** RIQ-5132: Screening IDs with Income Verification tag (tag 9), for "income received, needs work" indicator. */
  public incomeVerificationScreeningIds = new Set<number>();
  private screeningsLoadedSub: Subscription;

  public get screeningList() : Array<ScreeningLight> {
    if(!this.screenings.screenings) return [];
    return this.screenings.screenings;
  }

  public getRequestingUser(s: ScreeningLight) {
    try {
      if (this.users.users.length > 0) {
        const usr = this.users.users.find(c => {
          return c.id === (s.requestingUserId > 0 ? s.requestingUserId : s.initiatingUser);
        });
        return usr ? usr.userName : '';
      } else {
        return '';
      }
    } catch (error) {
    }
  }

  public viewUser(s: ScreeningLight) {
    this.location.navigateByUrl(`users/review/${s.requestingUserId > 0 ? s.requestingUserId : s.initiatingUser}/${s.clientId}`);
  }
  
  public viewClient(scrn: ScreeningLight) {
    this.location.navigateByUrl(`clients/review/${scrn.clientId}`);
  }

   public viewProperty(scrn: ScreeningLight) {
    this.location.navigateByUrl(`properties/stats/${scrn.locationId}/${scrn.clientId}`);
  }

  public savePropertyDecsion(s: ScreeningLight) {
    this.screenings.GetScreeningById(s.id).subscribe((scc: Screening) =>{
      scc.propertyDecision = s.propertyDecision;
      this.screenings.UpdateScreeningPIT(scc).subscribe((rsp : any)=>{
        //this ensures the cancel button doesn't hang around after clearing out a decision
        //see screening widget
        this.setEditState(s);
        this.toast.success('Property decision set successfully.');
      })
    },(err:any)=>{
      this.toast.error('Error setting property decision.');
    })
  }
  
  setEditState(s: ScreeningLight){
    s.editing = false;
    s.warned = false;
  }

  /** RIQ-5132: True when this screening has Income Verification tag (income received, needs work). */
  public hasIncomeVerificationTag(s: ScreeningLight): boolean {
    return s?.screeningId != null && this.incomeVerificationScreeningIds.has(s.screeningId);
  }

  public getUrl(scrn: ScreeningLight) : string{
    let url = `${window.location.origin}/${(this.processingListOrigin === true ? 'processingList' : 'screenings')}/review/${scrn.id}`;
    return url;
  }

  public viewScreening(scrn: ScreeningLight, setEditState: boolean = false, event:MouseEvent) {
    if(!scrn.locationActive && !this.auth.UserInRole("CRA")){
      this.toast.warning('Property Has Been Disabled', 'This report is locked until the location is reactivated, Please contact support for assistance.');
      return;
    }

    if(event && event.shiftKey) window.open(`${(this.processingListOrigin === true ? 'processingList' : 'screenings')}/review/${scrn.id}${setEditState ? '/Screening' : ''}`,'_blank').focus();
    else this.location.navigateByUrl(`${(this.processingListOrigin === true ? 'processingList' : 'screenings')}/review/${scrn.id}${setEditState ? '/Screening' : ''}`);
  }

  public linkApplicant(e: ScreeningLight): void {
    const modalRef = this.modalService.open(GroupApplicantComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.screeningLight = e;
    modalRef.componentInstance.name = 'GroupApplicants';
  }

  public unLinkApplicant(e: ScreeningLight): void {
    this.toast.info('Unlink in progress');
    this.groupSvc.unGroupApplicants(e).subscribe((resp: any) => {
      this.toast.success('Applicants ungrouped successfully', 'Link Success');
    }, (err: any)=>{
      this.toast.error('Unable to un-group applicants', 'Unlink Error');
    });
  }

  public removeReportTag(tagId: number, screening: ScreeningLight) {
    const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'RemoveReportTagAYS';
    modalRef.componentInstance.title = "Are you sure?";
    modalRef.componentInstance.confirmButtonText = "Clear Report Tag";
    modalRef.componentInstance.cancelButtonText = "Cancel";
    modalRef.componentInstance.alertBody = `This will remove the tag from report ${screening.invitationId}. Are you sure you want to continue?`;
    modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
      this.tagging.removeReportTag(tagId, screening.screeningId).subscribe({
        next: (data: any) => {
          this.screenings.screenings = this.screenings.screenings.filter(s => s.screeningId !== screening.screeningId);
          this.toast.success('Tag removed successfully for report '+ screening.invitationId, '', {  timeOut: 1500 });
          this.modalService.dismissAll();
        },
        error: () => {
          this.toast.error('Could not remove tag from report');
        }
      });
    });

  }

  ngOnInit() {
    this.screenings.screenings = [];
    // RIQ-5132: Load income-received IDs once when entering the list (not on every page change).
    if (this.showIncomeReceivedIndicator) {
      this.screenings.getIncomeVerificationTaggedIds().subscribe({
        next: (ids) => { this.incomeVerificationScreeningIds = new Set(ids ?? []); },
        error: () => { this.incomeVerificationScreeningIds = new Set(); }
      });
    }
    if(!this.skipInitialLoad) {
      if(this.craCheck)
        // this.screenings.FetchUnFilteredScreeningsList(0,this.pagination.pageIncrement);
        this.screenings.FetchFilteredScreeningsList(this.pagination.pageIncrement,0);
      else if(this.propertyId != undefined && this.propertyId > 0) {
        // let filter : SimpleDataFilter = new SimpleDataFilter('locationId', `${this.propertyId}`, true);
        this.screenings.screeningFilter.locationId = this.propertyId
        this.screenings.FetchFilteredScreeningsList();
      }
      else 
        this.screenings.FetchScreeningsForClient(this.clientId, this.take);

    }
  }

  orderResults(column : string){
    this.screenings.orderBy.orderByColumn = column;
    if(this.screenings.orderBy.designator == OrderByDesignator.Ascending) this.screenings.orderBy.designator = OrderByDesignator.Descending
    else this.screenings.orderBy.designator = OrderByDesignator.Ascending

    if(this.screenings.quickFilterApplied) {
      let col = column[0].toLowerCase() + column.substring(1);
      this.sortByKey(this.screeningList, col, (this.screenings.orderBy.designator == OrderByDesignator.Ascending ? true : false));
    }
    else {
      this.orderingTrigger.next(true);
      // console.warn(`Order by ${column} trigered ${this.screenings.orderBy.designator}`);
      // this.screenings.FetchFilteredScreeningsList(this.screenings.screeningFilter, this.screenings.orderBy);
    }
    

  }


  getSearches(s : ScreeningLight) {
    this.screenings.getSearches(s.screeningId).subscribe({
      next: (data : any) => {
        let dta = data.map(item => `${item.name}: ${item.stageName}`);
        const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'md' });
        modalRef.componentInstance.title = `Searches for ${s.invitationId}`;
        modalRef.componentInstance.alertBody = "";
        modalRef.componentInstance.listMode = true;
        modalRef.componentInstance.showButtons = false;
        modalRef.componentInstance.listItems = dta;
        modalRef.componentInstance.confirmButtonText = "Yes";
        modalRef.componentInstance.cancelButtonText = "Cancel";
          modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
            modalRef.dismiss()
          });
      },
      error: () => {
        this.toast.error('Could not load searches for report');
      }
    });
  }

  sortByKey(collection : any, key : string, asc : boolean) : any[] {
    return collection.sort((a, b) => {
      if(asc) {
        if(a[key] == b[key]) return 0;
        if(a[key] == null || a[key] == '') return 1;
        if(b[key] == null || b[key] == '') return -1;
        if(a[key] < b[key]) return -1;
        if(a[key] > b[key]) return 1;
      } else {
        if(a[key] == b[key]) return 0;
        if(a[key] == null || a[key] == '') return -1;
        if(b[key] == null || b[key] == '') return 1;
        if(a[key] > b[key]) return -1;
        if(a[key] < b[key]) return 1;
      }
    });
  }

}
